import styled, { keyframes } from 'styled-components';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import signInBackgroundImg from '../../assets/background-login-page-5.jpg';

export const Container = styled.div`
  height: 100vh;
  background: #47283a;
  display: flex;
  align-items: stretch;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 630px;
`;

export const FormBox = styled(Box)`
  width: 20vw;
  margin-top: 3px;
  @media (max-width: 500px) {
    width: 55vw;
  }

  @media (min-width: 500px) and (max-width: 900px) {
    width: 45vw;
  }
`;

export const PwdRequirements = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`;

export const ResetPasswordContent = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const InnerContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const appearFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const AnimationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  animation: ${appearFromLeft} 1s;

  form {
    margin: 20px 0;
    width: 340px;
    text-align: center;

    h1 {
      margin-bottom: 24px;
    }

    a {
      color: #f4ede8;
      display: block;
      margin-top: 24px;
      text-decoration: none;
      transition: color 0.2s;

      &:hover {
        color: '#f4ede8';
      }
    }
  }

  > a {
    color: #ff9000;
    display: block;
    margin-top: 24px;
    text-decoration: none;
    transition: color 0.2s;

    display: flex;
    align-items: center;

    svg {
      margin-right: 16px;
    }

    &:hover {
      color: '#ff9000';
    }
  }
`;

export const ContentRight = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
`;

export const BackgroundImg = styled.img`
  flex: 1;
  background: url(${signInBackgroundImg}) no-repeat center;
  background-color: #8cc1e3;
  background-size: 75rem;
`;

export const BackgroundDiv = styled.div`
  flex: 1;
  align-items: center;
  justify-content: center;
  background: #fff no-repeat center;
  background-color: white;
  background-size: 75rem;
`;

export const LoginTextField = styled(TextField)`
  & .MuiInputBase-root {
    height: 55px;
  }

  /* Prevent the browser from overriding the input styles on autofill */
  & input:-webkit-autofill,
  & input:-webkit-autofill:hover,
  & input:-webkit-autofill:focus,
  & input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 1000px #47283a inset;
    -webkit-text-fill-color: #fff;
    caret-color: #fff;
  }

  /* Remove the native reveal/clear icons (Edge) to avoid duplicating the IconButton */
  & input::-ms-reveal,
  & input::-ms-clear {
    display: none;
  }
`;

export const AuthTextField = styled(TextField)<{ $autofillBg?: string }>`
  /* Hide the browser's autofill background box by painting an inset box-shadow
     over it (same hack as LoginTextField). The box-shadow color must match the
     surface the input sits on: defaults to the page background, but pass an
     explicit $autofillBg when that surface isn't a plain theme color (e.g. a MUI
     Paper with an elevation overlay, as in forgotPassword). */
  & input:-webkit-autofill,
  & input:-webkit-autofill:hover,
  & input:-webkit-autofill:focus,
  & input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 1000px
      ${({ theme, $autofillBg }) =>
        $autofillBg ?? theme.colors.background.default}
      inset;
    -webkit-text-fill-color: ${({ theme }) => theme.colors.text.primary};
    caret-color: ${({ theme }) => theme.colors.text.primary};
  }

  /* Remove the native reveal/clear icons (Edge) to avoid duplicating the IconButton */
  & input::-ms-reveal,
  & input::-ms-clear {
    display: none;
  }
`;

export const CustomTextField = styled(TextField)`
  background: #232129;

  border-radius: 10px;
  border: 2px solid #232129;
  padding: 16px;
  width: 100%;
  color: rgb(250, 244, 238);
  display: flex;
  align-items: center;

  & + div {
    margin-top: 8px;
  }

  svg {
    margin-right: 16px;
  }
`;

export const PaperContainer = styled(Paper)`
  margin: 1;
  width: 45%;
  height: 70%;
  border-radius: 15px !important;

  @media (max-width: 800px) {
    width: 65%;
  }

  @media (max-width: 500px) {
    width: 85%;
    height: 75%;
  }
`;

export const SpanInfo = styled.span`
  @media (max-width: 800px) {
    font-size: 2.5dvw;
  }

  @media (max-width: 500px) {
    font-size: 3.5dvw;
  }

  @media (max-width: 300px) {
    font-size: 4.5dvw;
  }
`;

export const MiddleDiv = styled.div`
  height: 240px;

  @media (max-width: 350px) {
    margin-top: 15dvh;
  }
`;
